
import { UserDTO, UserInfoDTO } from "../user/dto";
import { AuthServiceImpl } from "./serviceImpl";

export interface AuthService {
    findMeUser(): Promise<UserDTO>
    findByUserId(request: string): Promise<UserInfoDTO>
}

export function NewAuthService(): AuthService {
    return new AuthServiceImpl();
}
